import { searchReportUserAcTransactionsLogs } from "../../../serviceBroker/transationReportApiServiceBroker";
import React, { FC } from "react";
import {
  PageEnum,
  ReportUserAcTransactionLogsParamsModel,
} from "../../../models";
import { ReportPage } from "../../../components";
import {formatToIsoString, getPageNameByPageId, getSystemLanguageId} from "../../../utils";
import { ReportUserAcTransactionsLogsSearchPanel } from "../../../components/reports/transactions/reportUserAcTransactionsLogsSearchPanel";

export const ReportUserTransactionsLogs: FC = () => {
  const initialState: ReportUserAcTransactionLogsParamsModel = {
    Lang: getSystemLanguageId(),
    fromDate: formatToIsoString(new Date()),
    toDate: formatToIsoString(new Date()),
  };
  return (
    <ReportPage
      InitialState={initialState}
      // SearchApi={searchReportUserTransactionsLogs}
      SearchApi={searchReportUserAcTransactionsLogs}
      searchHeader={getPageNameByPageId(PageEnum.frmReportTransactionLog)}
      SearchPanel={ReportUserAcTransactionsLogsSearchPanel}
      formId={PageEnum.frmReportTransactionLog}
    />
  );
};
